export const searchListPlaceholder = (resultsPerPage: number) =>
  new Array(resultsPerPage).fill(null).map((_v, id) => ({
    id: { raw: `placeholder_${id}` },
    loading: true
  }))
